import React, { useEffect, useState } from 'react';
import ListView from '../../components/views/listView';
import { HOME } from '../../../routes/paths';
import { useNavigate } from 'react-router-dom';
import { MasterMessage } from '../../../masters/masterMessages';
import { Tooltip, IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import ModalCaseManager from './ModalCaseManager';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { AutocompleteEditCell } from '../../components/general/fields/autocompleteEditCell';
import moment from 'moment/moment';
import Swal from 'sweetalert2';
import ModalLoading from '../../components/general/loading/modalLoading';
import { SwalCustomClass } from '../../components/general/toastSwal/swalCustomClass';
import {
    asyncGetUserByRol,
    asyncGetCaseManager,
    asyncPatchUserRandom,
    asyncPatchUserOneToOne,
} from '../../../services/caseManager.service';

const ListCaseManager = () => {
    const navigate = useNavigate();
    const {
        titleList,
        messageError,
        titleModalLoading,
        messageModalLoading,
        messageOneToOneOk,
        messageOneToOneError,
    } = MasterMessage.caseManager;
    const { caseManagement }: any = MasterMessage;
    const [rows, setRows] = useState<any>();
    const [users, setUsers] = useState<any>();
    const [lengthRows, setLengthRows] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(true);
    const [loadingModal, setLoadingModal] = useState<boolean>(false);
    const [open, setOpen] = useState<boolean>(false);
    const [idCase, setIdCase] = useState<string>('');
    const [page, setPage] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(20);
    const [saveLoad, setSaveLoad] = useState<boolean>(false);

    useEffect(() => {
        asyncGetUserByRol('user').then((body: any) => {
            if (body.items !== undefined) {
                setUsers(body.items.items);
            }
        });

        asyncGetCaseManager(page, pageSize)
            .then((body: any) => {
                if (body.items !== undefined) {
                    setRows(body.items.items);
                    setLengthRows(body.items.length);
                } else if (body.message !== undefined) {
                    SwalCustomClass.fire({
                        text: caseManagement[body.message],
                        icon: 'error',
                        iconColor: '#1d1d1d',
                    });
                }
            })
            .finally(() => setLoading(false));
    }, [page, pageSize, caseManagement, saveLoad]);

    const openModal = (id: string) => {
        setOpen(true);
        setIdCase(id);
    };

    const closeModal = (value: boolean) => {
        setOpen(value);
        setIdCase('');
    };

    const paginator = (paginationModel: any) => {
        if (paginationModel.page !== page) {
            setPage(paginationModel.page);
        } else if (paginationModel.pageSize !== pageSize) {
            setPageSize(paginationModel.pageSize);
        }
    };

    const onClickRandom = () => {
        setLoadingModal(true);
        asyncPatchUserRandom()
            .then((body: any) => {
                if (body.items !== undefined) {
                    Swal.fire({
                        title: 'Asignación Exitosa',
                        text: `Se asignaron ${body.items.length} registros exitosamente`,
                        icon: 'success',
                        iconColor: '#1d1d1d',
                        confirmButtonColor: '#1d1d1d',
                        customClass: 'swal-wide-class',
                    });
                    asyncGetCaseManager(page, pageSize).then((body: any) => {
                        if (body.items !== undefined) {
                            setRows(body.items.items);
                            setLengthRows(body.items.length);
                        }
                    });
                } else {
                    Swal.fire({
                        title: 'Error Asignaciones',
                        text: messageError,
                        icon: 'error',
                        iconColor: '#1d1d1d',
                        confirmButtonColor: '#1d1d1d',
                        customClass: 'swal-wide-class',
                    });
                }
            })
            .finally(() => setLoadingModal(false));
    };

    const asignateOneToOne = (userId: any, caseId: any) => {
        if (userId && caseId) {
            asyncPatchUserOneToOne(caseId, userId).then((body: any) => {
                if (body.items !== undefined) {
                    SwalCustomClass.fire({
                        text: messageOneToOneOk,
                        icon: 'success',
                        iconColor: '#1d1d1d',
                    });
                } else {
                    SwalCustomClass.fire({
                        text: messageOneToOneError,
                        icon: 'error',
                        iconColor: '#1d1d1d',
                    });
                }
            });
        }
    };

    const columns = [
        {
            field: 'field1',
            headerName: 'Número caso',
            minWidth: 150,
            flex: 0.5,
        },
        {
            field: 'field4',
            headerName: 'Fecha de creación',
            minWidth: 150,
            flex: 0.5,
            type: 'date',
            valueFormatter: (params: any) =>
                params?.value !== null
                    ? moment(params?.value).format('DD/MM/YYYY')
                    : null,
        },
        {
            field: 'field10',
            headerName: 'Propietario',
            minWidth: 120,
            flex: 0.5,
        },
        {
            field: 'createdBy',
            headerName: 'Creado Por',
            minWidth: 120,
            flex: 0.5,
            valueFormatter: (params: any) =>
                params?.value.name + ' ' + params?.value.surname || '',
        },
        {
            field: 'user',
            headerName: 'Asignado A',
            minWidth: 120,
            flex: 0.8,
            sortable: false,
            disableColumnMenu: true,
            filterable: false,
            editable: true,
            valueFormatter: (value: any) => {
                const { value: data } = value || undefined;
                if (data !== null) {
                    return data.name + ' ' + data.surname || '';
                }
            },
            renderEditCell: (params: any) => (
                <AutocompleteEditCell
                    params={params}
                    options={users}
                    freeSolo={true}
                    multiple={false}
                    getOptionLabel={(option: any) =>
                        option.name + ' ' + option.surname || ''
                    }
                    onSave={(value) => asignateOneToOne(value, params.row.id)}
                />
            ),
        },
        {
            field: 'seeMore',
            headerName: 'Ver Más',
            width: 100,
            sortable: false,
            disableColumnMenu: true,
            filterable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (row: any) => (
                <>
                    <Tooltip title="Ver Más">
                        <IconButton
                            size="small"
                            onClick={() => openModal(row.id)}
                        >
                            <InfoIcon type="submit" color="primary" />
                        </IconButton>
                    </Tooltip>
                </>
            ),
        },
    ];

    return (
        <>
            <ListView
                title={titleList}
                titleButtonAdd={'Asignar Todos'}
                onClickAdd={() => onClickRandom()}
                startIconButtonAdd={<AutorenewIcon color="secondary" />}
                onClickBack={() => navigate(HOME)}
                columns={columns}
                rows={rows}
                rowCount={lengthRows}
                disableRow={true}
                loading={loading}
                onSetPage={(paginationModel: any) => paginator(paginationModel)}
            />
            {open ? (
                <ModalCaseManager
                    open={open}
                    idCase={idCase}
                    onClose={(value) => closeModal(value)}
                    onSave={(value) => setSaveLoad(value)}
                />
            ) : null}
            {loadingModal ? (
                <ModalLoading
                    open={loadingModal}
                    title={titleModalLoading}
                    message={messageModalLoading}
                />
            ) : null}
        </>
    );
};

export default ListCaseManager;
